import { render, staticRenderFns } from "./HacizList.vue?vue&type=template&id=a1a2d6ca"
import script from "./HacizList.vue?vue&type=script&lang=ts"
export * from "./HacizList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports